export default {
  segment_labels: {
    active: 'Aktiv',
    cancelled: 'Storniert',
    completed: 'Abgeschlossen',
  },
};
